import "./RatingSummary.css";

const stars = [5, 4, 3, 2, 1];

export default function RatingSummary({ rating }) {
    const rounded = Math.round(rating.average);
    return (

        <div className="rating-summary">

            <div className="average">

                <h2>{rating.average}</h2>

                <div className="rating-stars">
                    {[1, 2, 3, 4,5].map(star => (
                        <span key={star}>
                            {star <= rounded ? "★" : "☆"}
                        </span>
                    ))}
                </div>

                <p>{rating.count} نظر</p>

            </div>

            <div className="bars">

                {stars.map(star => {

                    const total = rating.count || 1;

                    const value = rating.distribution[star] || 0;

                    const percent = value / total * 100;

                    return (

                        <div className="bar-row">

                            <span>{star}</span>

                            <div className="bar">
                                <div
                                    className="fill"
                                    style={{ width: `${percent}%` }}
                                />
                            </div>

                            <small>{Math.round(percent)}%</small>

                        </div>

                    )

                })}

            </div>

        </div>

    )

}